/**
 * Choisit un avatar par defaut deterministe pour un fan/user a partir de
 * son ID (ou n'importe quelle string stable). Le meme `seed` retourne
 * toujours le meme icone — l'user reconnait visuellement chaque fan meme
 * sans photo de profil.
 *
 * Les 12 icones vivent dans `src/avatars/` (meme personnage, 12 couleurs
 * differentes) : Vite les emporte au build de chaque app qui importe la librairie.
 */

const DEFAULT_AVATAR_COUNT = 12 as const;

/**
 * Hash 32-bit signe (variante DJB2 → bit-XOR pour rester un i32). Pas de
 * collisions visibles dans les centaines de fan IDs typiques d'un creator.
 */
function hashSeed(seed: string): number {
  let h = 0;
  for (let i = 0; i < seed.length; i++) {
    h = ((h << 5) - h + seed.charCodeAt(i)) | 0;
  }
  return Math.abs(h);
}

export function defaultAvatarFor(seed: string): string {
  const idx = (hashSeed(seed) % DEFAULT_AVATAR_COUNT) + 1;
  // Les douze SVG vivent avec la fonction (src/avatars) : Vite les emporte au build de chaque app.
  return new URL(`./avatars/default-${String(idx).padStart(2, "0")}.svg`, import.meta.url).href;
}
